import { sendMessageToWorker } from 'helpers/communication'
import { PersistentStorage } from 'database/PersistentStorage'

export const cleanup = async () => {
    sendMessageToWorker({ 'user info': {} })

    localStorage.clear()
    sessionStorage.clear()

    const rxInstance = await PersistentStorage.get()
    await rxInstance.destroy()
}
